import {CacheProvider} from "@emotion/react";
import {RemixBrowser, useLocation, useMatches} from "@remix-run/react";
// import * as Sentry from "@sentry/remix";
import {useCallback, useEffect, useState} from "react";
import {hydrateRoot} from "react-dom/client";

import ClientStyleContext from "./styles/client.context";
import createEmotionCache from "./styles/createEmotionCache";
/*
Sentry.init({
  dsn: "https://bbd2e07c25a75115a04fccb59cd7af50@o4507492598546432.ingest.de.sentry.io/4507492603199568",
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.replayIntegration(),
  ],
});
 */
function ClientCacheProvider({children}) {
  const [cache, setCache] = useState(createEmotionCache());

  const reset = useCallback(() => {
    setCache(createEmotionCache());
  }, []);

  return (
    <ClientStyleContext.Provider value={{reset}}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleContext.Provider>
  );
}

hydrateRoot(
  document,
  <ClientCacheProvider>
    <RemixBrowser />
  </ClientCacheProvider>,
);
